import { TENANT_BRANDING } from './branding.js';

export const TENANT_CONFIG = {
  ...TENANT_BRANDING,
  billingPlan: 'enterprise',
  // Le Blanc es un tenant/cliente. Solo declara qué módulos SaaS consume y sus overrides permitidos.
  moduleEntitlements: {
    dashboard: { enabled: true, label: 'Centro de Control' },
    reception: { enabled: true, label: 'Recepción y Turnos' },
    appointments: { enabled: true, label: 'Turnos' },
    specialists: { enabled: true, label: 'Profesionales' },
    surgery: { enabled: true, label: 'Quirófano', internal: true },
    inpatient: { enabled: true, label: 'Internación' },
    icu_adult: { enabled: true, label: 'UTI Adultos' },
    icu_neoped: { enabled: true, label: 'UTI Neo/Pediátrica' },
    cameras: { enabled: true, label: 'Control de Cámaras', internal: true },
    multichat: { enabled: true, label: 'MultiChat' },
    tenant_management: { enabled: true, label: 'Gestión del Tenant' },
    clinical_workspace: { enabled: true, label: 'Clinical Workspace', adapter: 'qoriax_native' }
  },
  healthServices: {
    inpatient_general: { serviceState: 'active', rollout: 'canary', visible: true },
    icu_adult: { serviceState: 'active', rollout: 'shadow', visible: true },
    icu_neoped: { serviceState: 'active', rollout: 'shadow', visible: true },
    day_hospital_oncology: { serviceState: 'standby', rollout: 'off', visible: false },
    day_hospital_nephrology: { serviceState: 'standby', rollout: 'off', visible: false },
    day_hospital_general: { serviceState: 'standby', rollout: 'off', visible: false },
    cath_lab: { serviceState: 'standby', rollout: 'off', visible: false },
    observation: { serviceState: 'standby', rollout: 'off', visible: false },
    post_anesthesia_care: { serviceState: 'active', rollout: 'shadow', visible: true }
  },
  channels: {
    whatsapp: { enabled: true, instance: 'qoriax-leblanc' },
    web_chat: { enabled: true }
  }
};

export default TENANT_CONFIG;
